export const settings = {
  selector: '.js-people-gallery-card',
  button: '.js-people-gallery-button',
}

/**
 * Function initializes all elements in page.
 */
export default function initAll() {
  let elements = document.querySelectorAll( settings.selector )
  Array.from( elements ).forEach(( element ) => {
    init( element )
  })
}

/**
 * Function initializes single element.
 * @param {DOMNode} element
 */
export function init( element ) {
  const buttons = element.querySelectorAll( settings.button )
  Array.from( buttons ).forEach(( buttonEl ) => {
    initContactButton( buttonEl )
  })
}

/**
 * Init contact button.
 *
 * @param {DOMNode} buttonEl
 */
const initContactButton = ( buttonEl ) => {
  buttonEl.addEventListener( 'click', ( event ) => {
    if ( !buttonEl.hasAttribute( 'clicked' )) {
      event.preventDefault()
      const title = buttonEl.dataset.title
      const span = buttonEl.querySelector( 'span' )
      span.innerText = title
      buttonEl.setAttribute( 'clicked', true )
    }
  })
}

